import { AxiosError } from 'axios';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Styles
import i18next from 'staff-management/src/i18n';
import styles from './DialogError.module.css';

// Components
import { Button } from '../../atoms/Button/Button';

/**
 * DialogError component
 * @param {object} props
 * @param {import('axios').AxiosError | Error} props.error
 * @param {() => void} props.resetErrorBoundary
 * @returns {JSX.Element} The rendered DialogError component.
 */
export function DialogError({ error, resetErrorBoundary }) {
  const { t } = useTranslation();
  // Call resetErrorBoundary() to reset the error boundary and retry the render.

  const errorMsg = useMemo(() => {
    if (error instanceof AxiosError) {
      return error.response?.data;
    }
    return null;
  }, [error]);

  const errorCodeTrans = useMemo(() => {
    if (errorMsg) {
      const key = `api.error.${errorMsg.code || errorMsg.detail}`;
      return i18next.exists(key) ? t(key) : null;
    }
    return null;
  }, [errorMsg]);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t('common.wrong')}</h1>
      <h2 className={styles.msg}>
        {errorMsg ? (
          <>
            <div className={styles.error}>
              {errorCodeTrans || ''}
            </div>
            <div className={styles.code}>
              {`Code: ${errorMsg.code || errorMsg.detail}`}
            </div>
          </>
        ) : error?.message}
      </h2>
      <Button onClick={resetErrorBoundary}>{t('common.retry')}</Button>
    </div>
  );
}

export default DialogError;
